import React from 'react';
import Form from '../../common/form/Form';
import { SCOPES } from '../../../constants/scopes.constants';
import AdvanceCapCard from './limitsForm/elements/AdvanceCapCard';
import VolumeAdvancedCapCard from './limitsForm/elements/VolumeAdvancedCapCard';
import FeeCapCard from './limitsForm/elements/FeeCapCard';
import MinMaxVolumeCard from './limitsForm/elements/MinMaxVolumeCard';
import styles from './limitsForm/styles/limitsForm.module.scss';

function LimitsForm({
    values = {},
    enabled = {},
    handlers = {},
    onCancel,
    onSubmit,
    loading,
    disabledSave,
    submitText,
    confirmBeforeSubmit = false,
    readOnly = false,
}) {
    return (
        <Form
            onSubmit={onSubmit}
            loading={loading}
            disabled={disabledSave}
            onCancel={onCancel}
            confirmBeforeSubmit={confirmBeforeSubmit}
            submitText={loading ? 'Saving...' : (submitText ?? 'Save')}
            readOnly={readOnly}
            submitGuardScope={SCOPES.CONFIGURATIONS_MANAGE}
        >
            <div className={styles.formGrid}>
                <AdvanceCapCard
                    value={values.maxAdvances}
                    timeframe={values.advanceTimeframe}
                    enabled={enabled.maxAdvances}
                    onChange={handlers.setMaxAdvances}
                    onChangeTimeframe={handlers.setAdvanceTimeframe}
                    onToggleEnabled={() => handlers.toggleLimitsSection('maxAdvances')}
                    tenureRules={values.advanceCapTenureRules}
                    onAddTenureRule={handlers.addAdvanceCapTenureRule}
                    onRemoveTenureRule={handlers.removeAdvanceCapTenureRule}
                    onUpdateTenureRule={handlers.updateAdvanceCapTenureRule}
                />
                <VolumeAdvancedCapCard
                    value={values.maxAdvanceVolume}
                    enabled={enabled.totalVolume}
                    onChange={handlers.setMaxAdvanceVolume}
                    onToggleEnabled={() => handlers.toggleLimitsSection('totalVolume')}
                    tenureRules={values.volumeCapTenureRules}
                    onAddTenureRule={handlers.addVolumeCapTenureRule}
                    onRemoveTenureRule={handlers.removeVolumeCapTenureRule}
                    onUpdateTenureRule={handlers.updateVolumeCapTenureRule}
                />
                <FeeCapCard
                    value={values.feeCap}
                    enabled={enabled.feeCap}
                    onChange={handlers.setFeeCap}
                    onToggleEnabled={() => handlers.toggleLimitsSection('feeCap')}
                />
                <MinMaxVolumeCard
                    min={values.minAdvanceAmount}
                    max={values.maxAdvanceAmount}
                    enabled={enabled.advanceAmounts}
                    onChangeMin={handlers.setMinAdvanceAmount}
                    onChangeMax={handlers.setMaxAdvanceAmount}
                    onToggleEnabled={() => handlers.toggleLimitsSection('advanceAmounts')}
                />
            </div>
        </Form>
    );
}

export default LimitsForm;
